import React from "react";
import { ScheduleTimes, SchedulePlaylists, Overlays } from ".";
import { InputBox, ErrorMessages } from "../../components";
import { ScheduleTimeInterface, ScheduleInterface, ApiHelper, ScreenInterface, PendingCommand } from "../../helpers";
import { Row, Col, FormGroup, FormLabel, FormControl } from "react-bootstrap"

interface Props {
  screen: ScreenInterface,
  schedule: ScheduleInterface,
  scheduleTimes: ScheduleTimeInterface[],
  updatedCallback: () => void
}

export const ScheduleDetails: React.FC<Props> = props => {

  const [schedule, setSchedule] = React.useState<ScheduleInterface>(null);
  const [errors, setErrors] = React.useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [timesCommand, setTimesCommand] = React.useState<PendingCommand>(null);
  const [playlistsCommand, setPlaylistsCommand] = React.useState<PendingCommand>(null);
  const [overlaysCommand, setOverlaysCommand] = React.useState<PendingCommand>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let s: ScheduleInterface = { ...schedule };
    let val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "name": s.name = val; break;
    }
    setSchedule(s);
  }

  const validate = () => {
    let errors: string[] = [];
    if (schedule.name === "") errors.push("Please enter a schedule name.");
    setErrors(errors);
    return errors.length === 0;
  }

  const handleSave = () => {
    if (validate()) {
      setIsSubmitting(true);
      ApiHelper.post("/schedules", [schedule]).then((data: ScheduleInterface[]) => {
        setTimesCommand({ action: "save", parameter: data[0].id.toString() });
      });
    }
  }


  const timesSaved = (scheduleId: number) => {
    setTimesCommand(null);
    setPlaylistsCommand({ action: "save", parameter: scheduleId.toString() });
  }

  const playlistsSaved = (scheduleId: number) => {
    setPlaylistsCommand(null);
    setOverlaysCommand({ action: "save", parameter: scheduleId.toString() });
  }

  const overlaysSaved = (scheduleId: number) => {
    setOverlaysCommand(null);
    setIsSubmitting(false);
    props.updatedCallback();
  }


  const getDeleteFunction = () => (schedule?.id > 0) ? handleDelete : undefined

  const handleDelete = () => {
    if (window.confirm("Are you sure you wish to permanently delete this schedule?")) {
      ApiHelper.delete("/schedules/" + schedule.id).then(() => { props.updatedCallback(); });
    }
  }

  const handleCancel = () => { props.updatedCallback(); }


  const init = () => { if (props.schedule) setSchedule(props.schedule); }

  React.useEffect(init, [props.schedule])


  return (
    <InputBox headerIcon="far fa-clock" headerText={"Schedule Details - " + schedule?.name} saveFunction={handleSave} isSubmitting={isSubmitting} deleteFunction={getDeleteFunction()} cancelFunction={handleCancel} >
      <ErrorMessages errors={errors} />
      <Row>
        <Col md={6}>
          <FormGroup>
            <FormLabel>Schedule Name</FormLabel>
            <FormControl id="name" value={schedule?.name} onChange={handleChange} />
          </FormGroup>
        </Col>
      </Row>
      <ScheduleTimes scheduleId={schedule?.id} scheduleTimes={props.scheduleTimes} saveCallback={timesSaved} pendingCommand={timesCommand} />
      <SchedulePlaylists scheduleId={schedule?.id} saveCallback={playlistsSaved} pendingCommand={playlistsCommand} screen={props.screen} />
      <Overlays scheduleId={schedule?.id} saveCallback={overlaysSaved} pendingCommand={overlaysCommand} screen={props.screen} />

    </InputBox>

  );
};